export const clearLocationState = () =>
  window.history.replaceState({}, document.title);
